module.exports = __webpack_public_path__ + "static/media/play-store.71bb620d.svg";